import React from 'react';

const TermsOfService = () => (
  <div>
    <h1>Terms of service</h1>
    <p>
      These terms of service (the &quot;Terms&quot;) apply to your use of the Fishbrain application,
      www.fishbrain.com, our other applications and tools, and any related services (collectively
      the &quot;Services&quot;) provided by Fishbrain AB, Reg. No 556796-5370, a company duly
      incorporated and organized under the laws of Sweden, having its registered address at
      Jakobsbergsgatan 31, 111 44 Stockholm, Sweden (&quot;Fishbrain&quot;). By accessing and/or
      using our Services, you thereby confirm that you have read and thereby agree to be bound by
      the Terms. If you are between 13 and 18 years of age, you hereby agree that your legal
      guardian has read these Terms and agree that you are bound by the Terms.
    </p>
    <h2>1. Services</h2>
    <p>
      Fishbrain&apos;s website and mobile applications are services for logging, tracking, and
      sharing sport fishing related information. By accepting these Terms, Fishbrain grants to you a
      non-exclusive, non-transferable, non-sublicensable, and limited right to access and use our
      Services for your own private purposes only, provided that your use is in accordance with
      these Terms.
    </p>
    <p>
      You acknowledge that you are fully responsible for the internet connection and/or mobile
      charges that you may incur for using our Services. Please consult your carrier, mobile
      operator, etc. for further information.
    </p>
    <p>
      While Fishbrain through these Terms gives you access and permission to use our Services in
      accordance with these Terms, you acknowledge that you are fully responsible for obtaining the
      relevant fishing permits or other authorizations, etc. needed in order to fish at a location
      which may be presented to you in our Services.
    </p>
    <h2>2. Content</h2>
    <p>
      Fishbrain holds the qualities of respect for others and originality of creation in high
      regard. When you use or interact with our Services and the other users of the Services you may
      elect to send, upload, communicate, transmit, or otherwise make available content, such as
      pictures, video, text, sound, information on your geographical position and other content
      (jointly &quot;Content&quot;), to us and/or other users of the Services. However, you agree
      that the Content you send, upload, communicate, transmit or otherwise make available:
    </p>
    <ul>
      <li>is true and does not constitute Content that is false or misleading;</li>
      <li>
        does not constitute any information likely to be deemed threatening, disparaging,
        defamatory, pornographic, racially or ethnically offensive, discriminatory, insulting,
        slanderous or otherwise illegal or inappropriate;
      </li>
      <li>
        does not constitute an infringement of the intellectual property (including copyright),
        publicity or privacy rights of any third party or otherwise violate such third party&apos;s
        rights;
      </li>
      <li>
        does not constitute information that you are not legally entitled to distribute (such as
        insider information or confidential information);
      </li>
      <li>
        does not contain any unsolicited or unauthorised advertising, promotional material,
        &quot;junk mail&quot;, &quot;spam&quot;, &quot;chain letters&quot;, &quot;pyramid
        schemes&quot; or any other form of solicitation; and
      </li>
      <li>
        does not contain software virus or any other technology that may harm the Services, or the
        interests or property of our Services or the other users of the Services.
      </li>
    </ul>
    <p>
      Fishbrain appreciates the opportunity to be notified of any objectionable or unauthorized use
      of Content, and users, rights holders and licensees are invited to inform Fishbrain of any
      potential violations by sending an email to us at support@fishbrain.com.
    </p>
    <p>
      Fishbrain hereby reserves the right in its absolute discretion to remove any Content from the
      Services, but is not required to do so. Fishbrain does not review Content and is therefore not
      responsible for any third party Content or Content provided by you or information contained
      therein, made available or otherwise used in connection with the Services, and is not
      responsible for the deletion or loss of any Content.
    </p>
    <p>
      In the event the Content you send, upload, communicate, transmit or otherwise make available
      gives rise to any intellectual or industrial property right (such as copyright), you thereby
      grant to Fishbrain an unlimited, non-exclusive, irrevocable, worldwide, perpetual,
      royalty-free, fully sublicensable and fully transferable right to use, copy, reproduce,
      change, modify, translate, transfer, make publicly available and/or perform such Content in
      relation to our Services. To the fullest extent permitted under applicable law, you waive your
      moral right to and/or in the Content. You acknowledge and agree that we may share Content with
      our partners and/or companies that we cooperate with.
    </p>
    <h2>3. User conduct</h2>
    <p>
      Certain rules must be complied with in order to maintain the integrity of the Services and to
      promote the user experience. You may only use the Services if:
    </p>
    <ul>
      <li>you are thirteen (13) years of age or above;</li>
      <li>
        you agree to use the Services for your own private purposes only and not for any commercial
        use, such as marketing or sale of goods or Services;
      </li>
      <li>
        you agree that you will only send, upload, communicate, transmit or otherwise make available
        Content that you own or otherwise are permitted to make available in the Services;
      </li>
      <li>
        <p>
          you agree that you will not use another person or entity&apos;s name or e-mail address
          when you use our Services;
        </p>
      </li>
      <li>
        if you create a user account, you agree that you will only create one account per platform,
        provide your full name and a valid e-mail address through which we will be able to contact
        you as well as any other step required in order to sign up for an account; you agree to keep
        your login details to your user account secure, which includes but is not limited to not
        disclosing your login details to anyone else or allowing someone else to use your login
        details or account; and you accept full responsibility for the activities carried out by the
        use of your account;
      </li>
      <li>
        you agree not to &quot;harvest&quot;, &quot;scrape&quot; or collect any personal information
        (such as user name and e-mail address) regarding other users of our Services without their
        consent;
      </li>
      <li>
        you agree not to decompile, disassemble or reverse engineer the Services or circumvent,
        deactivate or otherwise interfere with any technological measure or security-related feature
        of the Services; and
      </li>
      <li>you agree not to remove or amend any copyright or other proprietary notices.</li>
    </ul>
    <h2>4. Privacy</h2>
    <p>
      When you sign up for an account you provide personal details to us that may be deemed as
      personal information under the applicable legislation. Fishbrain is acting as the party
      responsible for your personal data. By using our Service, you agree to the collection and use
      of personal data in accordance with our Privacy Policy, which is published at:
      www.fishbrain.com/privacy.
    </p>
    <p>
      In addition, if you agree that our Services is allowed to interact with any third party (such
      as social network sites), you give us permission to use information which that third party
      shares with us. You are advised to read third party terms carefully to see what information
      they might share with us.
    </p>
    <h2>5. Cookies</h2>
    <p>
      When you visit or interact with our Services, Fishbrain or our authorized Services providers
      use cookies to store certain types of information for each time you visit or interact with our
      Services. By accepting these Terms you agree to Fishbrain using cookies in accordance with our
      Privacy Policy, which is published at: www.fishbrain.com/privacy .
    </p>
    <h2>6. Termination and cancellation</h2>
    <p>
      You may terminate your account and use of the Services at any time. You agree that Fishbrain
      may terminate your account and use of the Services if you breach these Terms. However,
      Fishbrain does not intend to take such actions in case of a minor breach. We may also cancel
      unconfirmed accounts or accounts that have been inactive for a long time.
    </p>
    <p>
      You hereby acknowledge that if either we or you terminate your account, all your Content will
      be made inaccessible.
    </p>
    <p>
      You hereby acknowledge and agree that as soon as you start using the Services you waive any
      statutory cancellation rights that you might otherwise have had.
    </p>
    <h2>7. Liability and indemnity</h2>
    <p>
      Nothing in these Terms excludes or limits our liability for death or personal injury arising
      from our negligence, or our fraud or fraudulent misrepresentation, or any other liability that
      cannot be excluded or limited by law.
    </p>
    <p>
      Under no circumstances shall Fishbrain&apos;s aggregate liability in connection with the
      Services or otherwise under these Terms exceed an amount corresponding to the greater of (a)
      SEK 100 (or the equivalent amount in your local currency), or (b) the aggregated fees which
      you paid to us in the 12 months prior to the action giving rise to the liability. Fishbrain,
      including its partners, affiliates, contractors, officers, directors, employees, and agents,
      shall not be liable for any loss of profit, loss of data or any other indirect damages in
      connection with the Services or otherwise under these Terms.
    </p>
    <p>
      You agree to indemnify and hold Fishbrain, its partners, affiliates, contractors, officers,
      directors, employees and agents harmless from and against any and all claims, losses,
      liabilities, expenses and damages related to your breach of these Terms.
    </p>
    <p>
      As a consumer you have special rights under mandatory consumer laws and regulations. We do not
      intend to limit or alter such rights under these Terms. Further we do not intend to impose a
      greater responsibility on you than you have under mandatory consumer laws and regulations.
    </p>
    <h2>8. Disclaimer of warranties</h2>
    <p>
      You agree that the Services are used at your own risk. Unless otherwise stated in these Terms,
      the Services are provided &quot;as is&quot; and Fishbrain disclaims any and all warranties,
      whether express or implied, relating to the Services, including but not limited to, accuracy,
      reliability, non-infringement or uninterrupted operation or access.
    </p>
    <h2>9. Assignment</h2>
    <p>
      Fishbrain is entitled to assign any of its rights and obligations under these Terms without
      restriction.
    </p>
    <h2>10. Modifications</h2>
    <p>
      Fishbrain may change the Services at any time, such as by adding or removing features or
      discontinuing the Services.
    </p>
    <p>
      In addition, Fishbrain is entitled to modify these Terms at any time. We will notify you of
      any major modifications to the Terms by email 30 days in advance, but you are advised to
      regularly review the latest version which is published at
      https://fishbrain.com/terms-of-service. If you do not wish to accept such Terms you can
      terminate your account. Any continued use by you of the Services following the notification of
      modified Terms shall constitute acceptance by you of such Terms.
    </p>
    <h2>11. Payment</h2>
    <p>
      You may subscribe to Fishbrain&apos;s premium service. If you are between 13 and 18 years of
      age your subscription only if your legal guardian has consented thereto. We may change our
      fees from time to time by posting the changes on the Fishbrain site or sending information by
      email 30 days in advance. If you continue to use the Services after the new fees apply you
      accept the new fees.
    </p>
    <h2>12. Refund policy of web subscriptions</h2>
    <p>
      A user, that purchased Fishbrain Pro via https://fishbrain.com/, will be refunded if a refund
      claim is made within 14 days after the purchase. The user needs to provide a receipt for the
      claim.
    </p>
    <p>
      All subscriptions bought through the App Store/Google Play Store fall under their respective
      policies.
    </p>
    <h2>13. Third party services</h2>
    <p>
      Fishbrain may include links to third party services and/or third party services may be made
      available to you via Fishbrain. These services are subject to respective third party terms and
      conditions. You are advised to read third party terms carefully as they constitute an
      agreement between you and the third party.
    </p>
    <h2>14. Intellectual property</h2>
    <p>
      You agree that all copyright, trademarks and other intellectual property rights relating to
      the Services are owned by Fishbrain or its licensors.
    </p>
    <h2>15. Entire Agreement</h2>
    <p>
      These Terms and all policies posted on our website represent the entire agreement between you
      and Fishbrain relating our Services, and replace all earlier agreements and understandings
      between you and us.
    </p>
    <p>
      If any provision of these Terms is held to be invalid, void or for any reason unenforceable,
      such provision shall be adjusted and shall not affect the validity and enforceability of the
      remaining provisions.
    </p>
    <h2>16. Applicable law and disputes</h2>
    <p>
      These Terms shall be governed by and construed in accordance with the laws of Sweden. We both
      agree that the courts of Sweden shall have non-exclusive jurisdiction to settle any dispute,
      controversy or claim arising out of, or in connection with, this Agreement, or the breach,
      termination or invalidity of the Agreement.
    </p>
  </div>
);

// Needs default to auto load correct file

export default TermsOfService;
